import {
  AutoCompleteMulti,
  ISelectType,
  useDebounce,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import {
  ChangeEvent,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { internalProcedureList } from "../../../../../../../../services/internalProcedure.service";
import { useTranslation } from "react-i18next";

interface IInternalProcedure {
  automationCode: string;
  params: object;
}

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedDaysAhead.";

export const DaysAheadInternalProcedure = memo(
  ({ automationCode, params }: IInternalProcedure) => {
    const { t } = useTranslation();

    const [
      optionsTicketAutomationReceivedDaysAheadProcedures,
      setTicketAutomationReceivedDaysAheadProcedures,
    ] = useState<ISelectType[]>([]);

    const [
      searchByTicketAutomationReceivedDaysAheadProcedures,
      setsearchByTicketAutomationReceivedDaysAheadProcedures,
    ] = useState("");

    const { sendRequest: proceduresRequest } = useFetch(internalProcedureList);

    const searchQuery = useDebounce(
      searchByTicketAutomationReceivedDaysAheadProcedures,
      500,
    );
    const paramsProcedure = useMemo(() => {
      return {
        SearchBy: searchQuery,
        EnableCode: true,
      };
    }, [searchQuery]);

    const procedureSearchBy = useCallback(
      (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setsearchByTicketAutomationReceivedDaysAheadProcedures(
          event.target.value.trim(),
        );
      },
      [],
    );

    const fetchTicketAutomationReceivedDaysAheadCaleProcedure =
      useCallback(async () => {
        if (automationCode !== "21") return;
        if (paramsProcedure.SearchBy.length < 3) {
          setTicketAutomationReceivedDaysAheadProcedures((prev) =>
            prev.length > 0 ? [] : prev,
          );
          return;
        }

        const { data, success } = await proceduresRequest(paramsProcedure);
        if (data && success) {
          setTicketAutomationReceivedDaysAheadProcedures(
            data.map((d) => ({
              id: d.identifier.toString(),
              name: d.procedureExamName,
            })),
          );
        }
      }, [paramsProcedure, automationCode, proceduresRequest]);

    useEffect(() => {
      fetchTicketAutomationReceivedDaysAheadCaleProcedure();
    }, [fetchTicketAutomationReceivedDaysAheadCaleProcedure]);

    return (
      <Grid item xs={12} sm={6}>
        <AutoCompleteMulti
          params={params}
          fullWidth
          value={searchByTicketAutomationReceivedDaysAheadProcedures}
          onChange={procedureSearchBy}
          options={optionsTicketAutomationReceivedDaysAheadProcedures}
          name="ticketAutomationReceivedDaysAheadProcedures"
          label={t(
            translationPath + "ticketAutomationReceivedDaysAheadProcedures",
          )}
          getOptionLabel={(option) => option.name}
          size="small"
          keepOpenOnSelect={true}
        />
        <Typography variant="caption" color="text.secondary" sx={{ mx: 3 }}>
          {t(translationPath + "procedure_caption")}
        </Typography>
      </Grid>
    );
  },
);
